import StraiCoinIcon from '@/Theme/icons/straicoin';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/outline';
import { inject, observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CoinsBadge = ({ store }) => {
  const navigate = useNavigate();

  const sleep = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  };
  const [coinsMark, setCoinsMark] = useState({
    box: 'bg-lavender text-violet-blue dark:bg-night-black dark:text-palladium h-8',
    icon: StraiCoinIcon,
    iconColor: 'text-violet-blue dark:text-palladium',
  });
  const [initialCoins, setInitialCoins] = useState(store.profile.credits);

  const animateCoinsDown = async () => {
    // First state - arrow down (common for both methods)
    setCoinsMark({
      box: 'bg-cool-gray text-nue-blue dark:bg-ship-grey dark:text-tropical-indigo h-8',
      icon: ArrowDownIcon,
      iconColor: 'text-nue-blue dark:text-tropical-indigo',
    });

    await sleep(800);

    // Different second states based on pricing method
    if (store.profile.pricing_method === 'perMessage') {
      // Pricing per Message - orange neon effect
      setCoinsMark({
        box: 'bg-transparent border border-[#f2a474] neon-effect-custom border-neon-custom dark:border-neon-dark-custom h-8',
        icon: StraiCoinIcon,
        iconColor: 'text-[#f2a474]',
      });

      await sleep(900);

      // Return to orange neon state
      setCoinsMark({
        box: 'bg-lavender text-violet-blue dark:bg-night-black dark:text-palladium h-8',
        icon: StraiCoinIcon,
        iconColor: 'text-violet-blue dark:text-palladium',
      });
    } else {
      // Standard pricing - normal effect
      setCoinsMark({
        box: 'bg-lavender text-violet-blue dark:bg-night-black dark:text-palladium h-8',
        icon: StraiCoinIcon,
        iconColor: 'text-violet-blue dark:text-palladium',
      });
    }
  };

  const animateCoinsUp = async () => {
    setCoinsMark({
      box: 'bg-cool-gray text-nue-blue dark:bg-ship-grey dark:text-tropical-indigo h-8',
      icon: ArrowUpIcon,
      iconColor: 'text-nue-blue dark:text-tropical-indigo',
    });

    await sleep(800);

    setCoinsMark({
      box: 'bg-lavender text-violet-blue dark:bg-night-black dark:text-palladium h-8',
      icon: StraiCoinIcon,
      iconColor: 'text-violet-blue dark:text-palladium',
    });
  };

  const ceroCoins = () => {
    setCoinsMark({
      box: 'bg-red-100 text-red-500 border border-red-100',
      icon: StraiCoinIcon,
      iconColor: 'text-red-500',
    });
  };

  useEffect(() => {
    if (initialCoins !== store.profile.credits) {
      let difference = store.profile.creditsPrevious - store.profile.credits;
      if (difference > 0) {
        animateCoinsDown();
      } else if (difference < 0) {
        animateCoinsUp();
      }
      setInitialCoins(store.profile.credits);
    }

    if (store.profile.credits <= 0) {
      ceroCoins();
    }
  }, [store.profile.credits]);

  return (
    <div
      onClick={() => navigate('/transactions')}
      className={`items-center flex ${coinsMark.box} font-normal text-base rounded-[0.625rem] px-2 my-1 mr-[2px] lg:mr-2 tracking-wide max-md:text-[26px] max-md:rounded-[37px] cursor-pointer transition-all duration-20 hover:shadow-md`}
    >
      <coinsMark.icon
        className={`w-6 h-6 max-md:w-[26px] max-md:h-[26px] ${coinsMark.iconColor} mr-0.5`}
      />
      {store.profile.credits?.toLocaleString('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </div>
  );
};

export default inject('store')(observer(CoinsBadge));
